module.exports = {"prices":{"location":"MME","per_day":"5.00","per_week":"40.00","two_week":"70.00","off_airport":null,"on_airport":"40.00","meet_and_greet":null,"per_day_off_airport":null,"per_day_on_airport":"5.00","per_day_meet_and_greet":null,"startDate":"25-08-2025","endDate":"01-09-2025","dateUsed":"25-06-2025"}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/prices/parking/MME.json
// module id = 145
// module chunks = 119